import { isNumber } from 'lodash';
import {
  code,
  flipHorizontal as flipH,
  flipVertical as flipV,
  rotateRight,
  settings as settingsIcon,
} from '@wordpress/icons';
import MediaInserter from './icon-inserter/media-library-inserter';
import { DEFAULT_ICON_WIDTH } from '@constants';

const {
  i18n: { __ },
  blockEditor: { BlockControls },
  components: {
    DropdownMenu,
    MenuGroup,
    MenuItem,
    ToolbarButton,
    ToolbarGroup,
  },
} = wp;

const BlockControlSettings = (prop) => {
  const {
    flipHorizontal,
    flipVertical,
    rotate,
    setAttributes,
    setCodeInserterOpen,
    setIconLibraryInserterOpen,
  } = prop;

  const setRotate = (value) => {
    const currentValue = isNumber(value) ? value : 0;
    // when current rotate value is 270 then we set new value to 0, otherwise add 90 to current value
    const newValue = currentValue === 270 ? 0 : currentValue + 90;
    setAttributes({ rotate: newValue });
  };

  const replaceDropdown = (
    <DropdownMenu icon="" text={__('Replace', 'b3rg')}>
      {({ onClose }) => (
        <>
          <MenuGroup>
            <MenuItem
              onClick={() => {
                setIconLibraryInserterOpen(true);
                onClose();
              }}
              icon={settingsIcon}
            >
              {__('Browse icon library', 'b3rg')}
            </MenuItem>
            <MediaInserter onClose={onClose} setAttributes={setAttributes} />
            <MenuItem
              onClick={() => {
                setCodeInserterOpen(true);
                onClose();
              }}
              icon={code}
            >
              {__('Add/edit custom icon', 'b3rg')}
            </MenuItem>
          </MenuGroup>
          <MenuGroup>
            <MenuItem
              onClick={() => {
                setAttributes({
                  icon: undefined,
                  iconName: undefined,
                  enableWidth: false,
                  width: DEFAULT_ICON_WIDTH,
                });
                onClose();
              }}
            >
              {__('Clear icon', 'b3rg')}
            </MenuItem>
          </MenuGroup>
        </>
      )}
    </DropdownMenu>
  );

  return (
    <BlockControls>
      <ToolbarGroup>
        <ToolbarButton
          className={`rotate-button-${rotate}`}
          icon={rotateRight}
          label={__('Rotate', 'b3rg')}
          onClick={() => setRotate(rotate)}
          isPressed={rotate}
        />
        <ToolbarButton
          icon={flipH}
          label={__('Flip Horizontal', 'b3rg')}
          onClick={() =>
            setAttributes({
              flipHorizontal: !flipHorizontal,
            })
          }
          isPressed={flipHorizontal}
        />
        <ToolbarButton
          icon={flipV}
          label={__('Flip Vertical', 'b3rg')}
          onClick={() =>
            setAttributes({
              flipVertical: !flipVertical,
            })
          }
          isPressed={flipVertical}
        />
      </ToolbarGroup>
      <ToolbarGroup>{replaceDropdown}</ToolbarGroup>
    </BlockControls>
  );
};

export default BlockControlSettings;
